import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Breadcrumbs from '../../../../../components/UI/Breadcrumbs';
import { translate, isNullOrEmpty, autoFocus, showMessageToastCustom } from '../../../../../utils/util';
import LoweringDeliveryService from '../../../../../services/LoweringDeliveryService';
import { Input } from '../../../../../components/UI/ComponentsUI';
import * as loweringDeliveryAction from '../../../../../actions/loweringDeliveryAction';

const DeliveryFilterByOrder = (props) => {
    const [orderCode, setOrder] = useState('');

    useEffect(() => {
        autoFocus("orderCode")
    }, []);

    const applyFilter = () => {
        if (!isNullOrEmpty(orderCode)) {
            props.getOrdersDeliverys({ orderCode: orderCode }, (data) => {
                if (data && data.length > 0) {
                    if (data.length === 1) {
                        props.setOrder(data[0]);
                        props.history.push({
                            pathname: `../startDelivery/order/missions/${data[0].items[0].orderItemId}`,
                            state: {
                                redirectFirst: true,
                            }
                        });
                    } else {
                        props.history.push({
                            pathname: '../ordersList'
                        });
                    }
                } else {
                    return showMessageToastCustom(translate('warning', 'general'), translate("no-item", "general"), 8000, 'mdi mdi-alert-circle-outline red-text');
                }

            })
        }
    };

    const titlePickingFilterByPartnumber = { icon: "mdi mdi-cart-check", label: translate('title', 'delivery') };
    const subtitlesPickingFilterByPartnumber = () => {
        return [{ icon: "mdi mdi-filter-variant", label: translate('line-picking:linepicking.filterByCIM') }];
    }

    return (
        <>
            <Breadcrumbs id="DeliveryFilterByPartnumber" title={titlePickingFilterByPartnumber} subtitles={subtitlesPickingFilterByPartnumber()} />
            <div className="container" style={{ marginTop: '40px', }}>
                <div className="row">
                    <div className="input-field no-padding col s12">
                        <Input
                            type="text"
                            label="Pedido"
                            id="orderCode"
                            name="orderCode"
                            onChange={(ev) => { setOrder(ev.currentTarget.value); }}
                            numericonly="true"
                            value={orderCode}
                        />
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <button
                        type="button"
                        className="col s12 m3
                        btn
                        btn-principal
                        waves-effect
                        waves-light"
                        onClick={() => applyFilter()}
                    >
                        {translate('apply', 'general')}
                    </button>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = () => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getOrdersDeliverys: (filter, callback) => {
            dispatch(LoweringDeliveryService.getOrdersDeliverys(filter, callback));
        },
        setOrder: (order) => {
            dispatch(loweringDeliveryAction.setOrder(order));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DeliveryFilterByOrder)));
